<app-nav titulo="Producto" descripcion="Seleccioná el tipo de producto para configurar sus fianzas y coberturas.">
    <div class="producto">
        <div class="producto-cards">
            <div class="producto-card" routerLink="/configuracion/calculadora/producto/vivienda">
                <mat-icon class="card-icon">home</mat-icon>
                <h3>Vivienda</h3>
                <p>Fianzas y coberturas para propiedades de uso habitacional.</p>
                <button mat-raised-button color="primary" class="garantor-button">Configurar</button>
            </div>
            <div class="producto-card" routerLink="/configuracion/calculadora/producto/comercial">
                <mat-icon class="card-icon">store</mat-icon>
                <h3>Comercial</h3>
                <p>Fianzas y coberturas para propiedades de uso comercial.</p>
                <button mat-raised-button color="primary" class="garantor-button">Configurar</button>
            </div>
        </div>
    </div>
</app-nav>
